import { http } from './http';
import { API_BASE_URL, ROUTES } from './config';
import { tokenStore } from './tokenStore';
import type { GeneratedReport, GenerateReportInput, ReportSchedule, ReportScheduleInput } from '../types/domain';

/** BillingService Exports & Reports client. manager+ only. */
export const reportsApi = {
  generate(body: GenerateReportInput): Promise<{ id: string }> {
    return http.post(ROUTES.reports.generate, body);
  },

  list(): Promise<GeneratedReport[]> {
    return http.get(ROUTES.reports.list);
  },

  get(id: string): Promise<GeneratedReport> {
    return http.get(ROUTES.reports.get(id));
  },

  delete(id: string): Promise<void> {
    return http.delete(ROUTES.reports.delete(id));
  },

  /** Bypasses the JSON client for the raw Blob with auth — same pattern as billingApi.exportCsv. */
  async download(id: string): Promise<Blob> {
    const token = tokenStore.get()?.accessToken;
    const response = await fetch(`${API_BASE_URL}${ROUTES.reports.download(id)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) throw new Error(`Download failed (${response.status})`);
    return response.blob();
  },

  listSchedules(): Promise<ReportSchedule[]> {
    return http.get(ROUTES.reports.schedules);
  },

  createSchedule(body: ReportScheduleInput): Promise<ReportSchedule> {
    return http.post(ROUTES.reports.schedules, body);
  },

  updateSchedule(id: string, body: ReportScheduleInput): Promise<void> {
    return http.put(ROUTES.reports.schedule(id), body);
  },

  deleteSchedule(id: string): Promise<void> {
    return http.delete(ROUTES.reports.schedule(id));
  },
};
